import { Controller } from 'stimulus';
// import { saveState, restoreState } from '../location_hash';

function tabName(el) {
  return `#${el.dataset.tabName}`;
}

export default class extends Controller {
  static targets = ['tab', 'panel', 'selected'];

  initialize() {
    this.activeTabClasses = (this.data.get('activeTab') || 'active').split(' ');
    this.tabTargets.forEach((el, index) => {
      if (window.location.hash === tabName(el)) this.index = index;
    });
    this.showTab();
  }

  change(event) {
    event.preventDefault();
    this.index = this.tabTargets.indexOf(event.currentTarget);
  }

  showTab() {
    this.tabTargets.forEach((tab, index) => {
      const panel = this.panelTargets[index];
      panel.classList.toggle('hidden', index !== this.index);

      if (index === this.index) {
        tab.classList.add(...this.activeTabClasses);
      } else {
        tab.classList.remove(...this.activeTabClasses);
      }
    });
  }

  get selected() {
    if (!this.hasSelectedTarget) return null;

    return this.selectedTarget.value;
  }

  set selected(value) {
    if (!this.hasSelectedTarget) return;

    this.selectedTarget.value = value;
  }

  get index() {
    return parseInt(this.data.get('index') || this.selected || 0, 10);
  }

  set index(value) {
    this.data.set('index', value);
    this.selected = value;
    this.showTab();
  }
}
